module.exports = __webpack_public_path__ + "static/media/the_carbon_challenge-tablet.2f165f43.jpg";